/* eslint-disable no-unused-vars */
import { Badge, Box } from '@mui/material'
import CellHOC from '@platform/react/hoc/list/cell'
import Icon from 'ui/Element/Icon'

/**
 * Styling for the icon.
 *
 * @param {Object} theme
 * @returns {{
 * root: {alignItems: string, color, display: string, width: string},
 * icon: {alignItems: string, display: string}
 * }}
 */
const styles = theme => ({
  root: {}, // we need this overwrite 'overflow: hidden' from CellHOC
  badge: {
    padding: 0,
    width: '1.25rem', // 20px
    height: '1.25rem', // 20px
    backgroundColor: theme.palette.primary.main,
  },
  container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    height: '5rem',
    width: '2.5rem',
  },
})

/**
 * Intended to display an icon for the cart.
 *
 * @param {Object} classes  styling for the cell
 * @param {Object} props    props for the cell
 *
 * @returns {JSX.Element}
 */
export const ListItemCellCartIcon = (classes, props = {}) => {
  const { status, cartIcon, purchaseRequestIcon } = props

  const icon = (
    <Icon
      source={purchaseRequestIcon}
      color={'text.secondary'}
      background={'background.content'}
      shape={'circle'}
    />
  )
  const badge = (
    <Badge
      classes={{ badge: classes.badge }}
      badgeContent={
        <Icon
          source={cartIcon}
          color={'white'}
          size={'0.625rem'} // 10px
        />
      }
    >
      {icon}
    </Badge>
  )

  return (
    <Box className={classes.container}>
      {status === 50 ? badge : icon}
    </Box>
  )
}

export default CellHOC(ListItemCellCartIcon, styles)
